import { getPath } from '@/router/common'

const baseUrl = {
  title: '货源信息',
  path: 'HYInfo'
}

export default [
{
    path: getPath('index', baseUrl),
    name: 'HYInfo_index',
    component: () => import(/* webpackChunkName: "HYInfo_index" */ '@/views/hYInfo/index/index.vue'),
    meta: {
      title: '货源信息'
    }
  }
]